export const requestErrorMessage = 'There was an error with your request'

export const defaultError422 = 'There are some errors in your form.'

export const defaultDownloadError = 'There was an error downloading the file'
